import React from "react";
import logoIcon from "../assets/record.svg";
import logoText from "../assets/genrebender.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MainNav = (props) => {
  return (
    <div className="wideWrapper">
      <div className="mainNav">
        <div className="navLogo" onClick={props.handleReset}>
          <img src={logoIcon} alt="An illustration of a record" className="logoIcon" />
          <img src={logoText} alt="GenreBender" className="logoText" />
        </div>
        <div className="navButtons">
          {props.userInfo ? <a href={props.userInfo.url} className="loginButton" target="_blank" rel="noopener noreferrer">
            <div className="userImage" style={{ backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundImage: `url(${props.userInfo.imgURL})` }} />
            {props.userInfo.name}
          </a> : <a href="https://genrebenderapp.herokuapp.com/auth" className="loginButton">
              <FontAwesomeIcon icon={['fab', 'spotify']} style={{ marginRight: '0.75rem' }} />
              Log in
        </a>}
          <button onClick={props.showModal} id="showInfo" className="infoButton">
            <FontAwesomeIcon icon="info-circle" />
          </button>
        </div>
      </div>
    </div>
  )


}

export default MainNav;